//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'JusticeIsBlindInfo',

    modalClass: 'modal-content modal-content--sm',

    methods: {
        trackJoin() {
            this.$gtag.event('jib-join')
        },

        close() {
            this.$gtag.event('jib-close')
            this.$vuedals.close(this)
        },
    },
}
